import React, { useState } from 'react';
import {
  Popup, Icon, Form
} from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import LanguageGetter from '../user/userProfileBuilder/fields/languages';
import {
  updateSearchFilters
} from '../../modules/betaOpportunities';
import useOutsideClick from '../../hooks/useOutsideClick';

const DiscoverFilter = ({
  t
}) => {
  const dispatch = useDispatch();
  const hideAiGenerated = useSelector(state => state.user?.userProfile?.showAiGeneratedManuscripts === false);

  const searchFilters = useSelector(state => state.betaOpportunities.searchFilters) || {};

  const [open, setOpen] = useState(false);
  const language = searchFilters?.language ?? [];
  const filterRef = React.useRef();

  useOutsideClick(filterRef, () => {
    // close when clicking outside
    setOpen(false);
  });


  const handleLanguageChange = (languages) => {
    dispatch(updateSearchFilters({
      ...searchFilters,
      language: languages.filter(l => l !== null)
    }))
  }

  const hasFilters = () => {
    return language.length > 0 || !!searchFilters.ai || hideAiGenerated;
  }

  const toggleOpen = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(!open);
  }

  return (
    <Popup
      hoverable
      basic
      position='bottom center'
      open={open}
      trigger={(
        <Icon.Group
          style={{ opacity: 0.4 }}
        >
          <Icon
            name={open ? 'chevron up' : 'chevron down'}
            link
            onClick={toggleOpen}
          />
          {
            hasFilters() && (
              <Icon
                name='add'
                corner='top right'
              />
            )
          }
        </Icon.Group>
      )}
      content={(
        <div style={{ minWidth: 300 }} ref={filterRef}>
          <Form.Select label='Manuscript AI use' value={searchFilters.ai || 'all'}
            options={[['all', 'All manuscripts'], ['human', 'Human-written'], ['assisted', 'AI-assisted'], ['generated', 'Contains AI-generated text'], ['no_generated', 'Declared without generated text or translation'], ['undeclared', 'Not yet declared']].map(([value, text]) => ({key: value, value, text, disabled: hideAiGenerated && value === 'generated'}))}
            onChange={(_, d) => {try {localStorage.setItem('br-discovery-ai', d.value);} catch (_) {} dispatch(updateSearchFilters({...searchFilters, ai: d.value === 'all' ? undefined : d.value}));}} />
          {hideAiGenerated && <p>{t('AiManuscriptPreferenceHidden')}</p>}
          <p><Link to="/account/profile">{t('AiManuscriptPreferenceSettings')}</Link></p>
          <LanguageGetter
            header={t('Languages')}
            subheader={false}
            initialValue={language}
            onUpdate={handleLanguageChange}
            autoUpdate
          />
        </div>
      )}
    />
  );
}

export default withTranslation()(DiscoverFilter);
